import React from "react"
import Layout from "../components/App/Layout"
import PageBanner from '../components/App/PageBanner'
import { SupportRequest } from "../components/Zammad/SupportRequest"
import SEO from "../components/App/SEO"
import { useTranslation } from "../plugins/i18next/ea-react-i18next";
import { graphql } from "gatsby"

export const Head = () => {
  return <SEO title='support.title' description='support.description' />;
};

const Support = () => {
  const { t } = useTranslation('pages', {keyPrefix: "support"});
  return <Layout>
      <PageBanner
        pageTitle={t('title')}
        homePageText={t('home')}
        homePageUrl="/"
      />
      <SupportRequest />
    </Layout>
}

export default Support

export const query = graphql`
query ($language: String) {
  locales: allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
    edges {
      node {
        ns
        language
        data
      }
    }
  }
}
`;